'use client'

import Link from 'next/link'

import { Heading, Paragraph } from '@graftcode/design-system'

import { CtaFooter } from '@/modules/academy/components/CtaFooter'
import { ACADEMY_ROUTES } from '@/shared/academy.const'

import { YouTubeEmbed } from './components/YouTubeEmbed/YouTubeEmbed'
import { VIDEOS_TEST_IDS } from './videos.const'
import type { AcademyVideo } from './videos.interface'

import styles from './VideoDetailPage.module.scss'

type VideoDetailPageProps = {
  video: AcademyVideo
}

export function VideoDetailPage({ video }: VideoDetailPageProps) {
  const topicLabel = video.primaryTopicLabel ?? ''
  const youtubeWatchUrl = `https://www.youtube.com/watch?v=${video.youtubeVideoId}`

  const handleTryGraftcode = () => {
    const portalUrl = process.env.NEXT_PUBLIC_WEB_PORTAL_URL || 'https://portal.graftcode.com'
    window.open(portalUrl, '_blank')
  }

  return (
    <div className={styles.page} data-testid={VIDEOS_TEST_IDS.detailPage}>
      <div className={styles.content}>
        <Link href={ACADEMY_ROUTES.videos} className={styles.backLink}>
          Back to Videos
        </Link>
        <YouTubeEmbed youtubeVideoId={video.youtubeVideoId} title={video.title} thumbnailUrl={video.thumbnailUrl} />
        <div className={styles.meta}>
          <Heading type="h1" className={styles.title}>
            {video.title}
          </Heading>
          <div className={styles.metaRow}>
            {topicLabel ? <span className={styles.topic}>{topicLabel}</span> : <span />}
            <span className={styles.duration}>{video.duration}</span>
          </div>
          {video.description ? <Paragraph className={styles.description}>{video.description}</Paragraph> : null}
          <a href={youtubeWatchUrl} className={styles.youtubeLink} target="_blank" rel="noopener noreferrer">
            Watch on YouTube
          </a>
        </div>
      </div>
      <CtaFooter onTryGraftcode={handleTryGraftcode} />
    </div>
  )
}
